var map = {
	"./auto-grow-textarea_controller.js": 221,
	"./correcties_controller.js": 222,
	"./delete_controller.js": 223,
	"./drag_controller.js": 224,
	"./dropfile_controller.js": 242,
	"./hello_controller.js": 225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;